import ReportWrapper from '../ReportWrapper'
import React from 'react'
import FailureComplyCasesOverview from './FailureComplyCasesOverview'
import FailureComplyCase from './FailureComplyCase'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import ItemWrapper from '../../../components/ItemWrapper'
import { Stack, Text } from '@mantine/core'
import ReportSectionHeading from '../ReportSectionHeading'
import { useTheme } from '../../../components/ThemeProvider'

interface FailureComplyCasesProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function FailureComplyCases({ data, title, sectionIndex }: FailureComplyCasesProps) {
  const theme = useTheme()
  const cases = data?.dishonest_case_info ?? []
  const caseCount = cases.length

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <FailureComplyCasesOverview data={data} />
      <ItemWrapper className="mt-2">
        <Stack gap="md">
          <div>
            <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
              失信被执行案件
            </Text>
            <Text size="xs" className="text-gray-500" style={{ marginTop: '4px' }}>
              {caseCount > 0
                ? `监测到 ${caseCount} 条失信被执行记录，请结合法院信息核实履行情况。`
                : '未检索到失信被执行案件记录。'}
            </Text>
          </div>
          <ExpandableListWrapper isEmpty={caseCount === 0}>
            {cases.map((item: any, index: number) => (
              <FailureComplyCase number={index + 1} key={index} item={item} />
            ))}
          </ExpandableListWrapper>
        </Stack>
      </ItemWrapper>
    </ReportWrapper>
  )
}
